module.exports = __webpack_public_path__ + "static/media/rassIcon.82847266.svg";